<template>

    <div class="rating-toolbar">
        <v-btn 
            @click="handleSelectRating('good')"
            @mouseenter="showToolTip($t('RATING_GOOD_TOOLTIP'))"
            @mouseleave="hideToolTip"
            density="compact" 
            icon="mdi-thumb-up"
            variant="text"
            size="small"
            :class="isSelected('good') ? 'selected' : ''"
            :disabled="disableRatingButton"
            :loading="requestInProgress"
        ></v-btn>

        <v-btn 
            @click="handleSelectRating('neutral')"
            @mouseenter="showToolTip($t('RATING_NEUTRAL_TOOLTIP'))"
            @mouseleave="hideToolTip"
            density="compact" 
            icon="mdi-emoticon-neutral"
            variant="text"
            size="small"
            :class="isSelected('neutral') ? 'selected' : ''"
            :disabled="disableRatingButton"
            :loading="requestInProgress"
        ></v-btn>
        
        <v-btn 
            @click="handleSelectRating('bad')"
            @mouseenter="showToolTip($t('RATING_BAD_TOOLTIP'))"
            @mouseleave="hideToolTip"
            density="compact" 
            icon="mdi-thumb-down"
            variant="text"
            size="small"
            :class="isSelected('bad') ? 'selected' : ''"
            :disabled="disableRatingButton"
            :loading="requestInProgress"
        ></v-btn>
        
        <div v-if="ratingSubmitted" class="feedback-msg">{{ $t('FEEDBACK_GIVEN_MESSAGE') }}</div>
    </div>   
    
    <ToolTip :message="tooltipMessage"  ref="tooltip" />

</template>

<script>
    import ToolTip from '@/components/tooltip.vue';

    export default {
        name: "RatingToolbar",
        components: {
            ToolTip
        },
        props: {
            callbackFunc: {
                type: Function,
                required: true
            },
            currentRating: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                inProgress: false,
                tooltipMessage: '',
            };
        },
        methods: {
            async handleSelectRating(rating) {
                this.setInProgress(true);

                this.hideToolTip();

                await this.callbackFunc(rating);

                this.setInProgress(false);
            },
            isSelected(rating) {
                return this.currentRating === rating;
            },
            setInProgress(inProgress) {
                this.inProgress = inProgress;
            },
            showToolTip(message) {
                this.tooltipMessage = message;
                this.$refs.tooltip.showTooltip = true;
            },
            hideToolTip() {
                this.tooltipMessage = '';
                this.$refs.tooltip.showTooltip = false;
            }
        },
        computed: {
            ratingSubmitted() {
                return this.currentRating !== "-";
            },
            ratingPending() {
                return this.currentRating === "-";
            },
            requestInProgress() {
                return this.inProgress;
            },
            disableRatingButton() {
                return this.ratingSubmitted || this.requestInProgress;
            }
        }
    }

</script>

<style scoped>

    .rating-toolbar {
        display: flex;
        align-items: center;
        background: transparent;
        padding: 6px 0;
        min-height: 48px;
    }

    .rating-toolbar button {
        opacity: 0.33;
        margin: 0 6px 0 0;
    }

    .rating-toolbar button.selected {
        opacity: 1;
    }

    .rating-toolbar button.selected:disabled {
        opacity: 1;
    }

    .rating-toolbar button:not(:disabled):hover {
        opacity: 0.66;
    }

    .rating-toolbar .feedback-msg {
        margin: 0 8px;
        color: #999;
        font-size: 14px;
        font-weight: 600;
    }

    .small-viewport .rating-toolbar .feedback-msg {
        font-size: 12px;
    }
</style>